module.exports = __webpack_public_path__ + "img/solution-farmer-banner.b72ce8b2.jpg";